export const taskFileThumbnailTypeDef = `
  type
  width
  height
  quality
  src
`;
